import { set, unset, when } from 'cerebral/operators'

import deleteUser from '../actions/deleteUser.js'
import removeUserFromApprovedArray
  from '../actions/removeUserFromApprovedArray.js'
import removeUserFromUnapprovedArray
  from '../actions/removeUserFromUnapprovedArray.js'
import shouldRemoveUnApprovedView
  from '../actions/shouldRemoveUnApprovedView.js'
import isSameAsDeletedUser from '../actions/isSameAsDeletedUser'
import logout from './logout'
import redirect from 'cerebral-module-router/redirect'

export default [
  deleteUser,
  {
    success: [
      isSameAsDeletedUser,
      {
        true: [...logout],
        false: [
          when('state:users.currentView', ['unapproved']),
          {
            unapproved: [
              removeUserFromUnapprovedArray,
              shouldRemoveUnApprovedView,
              {
                true: [
                  set('state:users.currentView', 'approved'),
                  redirect('/users')
                ],
                false: [redirect('/users/unapproved')]
              }
            ],
            otherwise: [removeUserFromApprovedArray, redirect('/users')]
          }
        ]
      }
    ],
    error: []
  },
  unset('client.delete.user')
]



// WEBPACK FOOTER //
// ./src/modules/user/chains/deleteUser.js